import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, ArrowUpRight } from "lucide-react";
import Logo from "./Logo";
import { navItems, cn } from "./SharedUI";

export default function Nav() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  // Top-level visible nav: drop Home (renders via logo) and Contact (rendered as CTA)
  const visible = navItems.slice(1, -1);

  return (
    <header data-testid="site-nav" className="sticky top-0 z-40 border-b border-stone-200 bg-[#FAFAF9]/85 backdrop-blur-md">
      <nav className="mx-auto flex max-w-[1400px] items-center justify-between px-6 md:px-10 lg:px-16 py-3.5">
        <Link to="/" data-testid="nav-home-link" onClick={() => setOpen(false)}>
          <Logo />
        </Link>

        <div className="hidden xl:flex items-center gap-5">
          {visible.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, '-')}`}
              className={({ isActive }) =>
                cn(
                  "text-[12px] tracking-tight transition-colors whitespace-nowrap",
                  isActive
                    ? "text-stone-900 font-semibold"
                    : "text-stone-600 hover:text-stone-900"
                )
              }
            >
              {l.label}
            </NavLink>
          ))}
        </div>

        <div className="flex items-center gap-2">
          <Link
            to="/contact"
            data-testid="nav-contact-cta"
            className={cn(
              "hidden md:inline-flex items-center gap-1.5 text-[13px] font-medium px-4 py-2 rounded-sm border transition-colors whitespace-nowrap",
              pathname === "/contact"
                ? "bg-stone-900 text-white border-stone-900"
                : "border-stone-300 text-stone-900 hover:bg-stone-900 hover:text-white hover:border-stone-900"
            )}
          >
            Request Access <ArrowUpRight className="h-3.5 w-3.5" />
          </Link>
          <button
            className="xl:hidden p-2 -mr-2 text-stone-900"
            onClick={() => setOpen((v) => !v)}
            data-testid="nav-mobile-toggle"
            aria-label="Toggle menu"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </nav>

      {open && (
        <div className="xl:hidden border-t border-stone-200 bg-[#FAFAF9]" data-testid="nav-mobile-panel">
          <div className="px-6 py-4 flex flex-col gap-1 max-h-[75vh] overflow-y-auto">
            {navItems.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, '-')}`}
                className={({ isActive }) =>
                  cn(
                    "py-2.5 text-[15px] border-b border-stone-200",
                    isActive ? "text-stone-900 font-semibold" : "text-stone-700"
                  )
                }
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
